function closeAllCustomSelects() {
  document.querySelectorAll('.custom-select[aria-expanded="true"]').forEach((select) => {
    select.setAttribute('aria-expanded', 'false');
  });
}

function initCustomSelects() {
  document.querySelectorAll('.custom-select:not([data-initialized])').forEach((select) => {
    select.dataset.initialized = 'true';

    const trigger = select.querySelector('.custom-select__trigger');
    const options = select.querySelectorAll('.custom-select__option');
    const valueDisplay = select.querySelector('.custom-select__value');
    const selectId = select.dataset.selectId;
    const nativeSelect = document.getElementById(selectId);

    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = select.getAttribute('aria-expanded') === 'true';
      closeAllCustomSelects();
      if (!isOpen) {
        select.setAttribute('aria-expanded', 'true');
      }
    });

    options.forEach((option) => {
      option.addEventListener('click', () => {
        const value = option.dataset.value;
        valueDisplay.textContent = option.textContent.trim();
        options.forEach((o) => {
          o.classList.remove('custom-select__option--selected');
          o.setAttribute('aria-selected', 'false');
        });
        option.classList.add('custom-select__option--selected');
        option.setAttribute('aria-selected', 'true');
        if (nativeSelect) {
          nativeSelect.value = value;
          nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
        select.setAttribute('aria-expanded', 'false');
      });
    });
  });

  document.addEventListener('click', closeAllCustomSelects);
}

document.addEventListener('DOMContentLoaded', initCustomSelects);